module.exports = " <div class=news-list__item v-if=article> <h1 class=news-title>{{{article.Name}}}</h1> <time class=news-date>{{article.ItemDate}}</time> <p class=news-leading>{{{article.Introduction}}}</p> <a v-link=\"'/news/'+article.Id\" class=simple-button>{{getResource('ReadMore')}}</a> </div> <loading v-else class=news-list__loading></loading> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/views/home/HomeNewsItem.vue
// module id = 193
// module chunks = 0